<template>
  <BaseTable
    ref="table"
    title="Utenti"
    :headers="headers"
    :actions="actions"
    :elevation="0"
    :exportable="canUser('customers.users', 'download')"
    module="customersUsers"
  >
    <template v-slot:item.code="{ item }">
      <v-chip label>{{ item.code | placeholder('N/A') }}</v-chip>
    </template>
    <template v-slot:item.is_vip="{ item }">
      <v-chip v-if="item.is_vip" small label color="amber darken-2" dark>
        <v-icon small left>mdi-star</v-icon>VIP
      </v-chip>
      <span v-else>—</span>
    </template>
    <template v-slot:actions>
      <v-btn
        v-if="canUser('customers.users', 'create')"
        color="green"
        dark
        tile
        depressed
        @click="openModal"
      >
        Aggiungi
      </v-btn>
    </template>
    <template v-slot:footer>
      <v-dialog
        v-model="dialog"
        max-width="75%"
        :fullscreen="$vuetify.breakpoint.mobile"
        :retain-focus="false"
        @click:outside="modalClose"
      >
        <v-card>
          <v-card-title>Aggiungi Utente</v-card-title>
          <v-card-text>
            <CustomerUsersForm
              v-if="dialog"
              :edit="editMode"
              @submitted="onSubmitted"
            />
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
  </BaseTable>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import BaseTable from '@components/structure/base-table.vue'
import { createHelpers } from 'vuex-map-fields'
import { authComputed } from '@state/helpers.js'
import CustomerUsersForm from '@components/customer_users/CustomerUsersForm.vue'
import utils from '@mixins/utils.js'

const { mapFields: mapCustomersUsersFilters } = createHelpers({
  getterType: 'customersUsers/getFiltersFields',
  mutationType: 'customersUsers/SET_FILTER_FIELDS',
})

export default {
  name: 'CustomerUsers',
  mixins: [utils],
  components: { CustomerUsersForm, BaseTable },
  data() {
    return {
      dialog: false,
      editMode: false,
      actions: [
        {
          label: 'Modifica',
          icon: 'mdi-pencil',
          color: 'primary',
          onItemCondition: () => this.canUser('customers.users', 'update'),
          handler: this.openModal,
        },
        {
          label: 'Elimina',
          icon: 'mdi-delete',
          color: 'red',
          onItemCondition: () => this.canUser('customers.users', 'delete'),
          handler: this.remove,
        },
      ],
    }
  },
  computed: {
    ...authComputed,
    ...mapState('customers', {
      customer: (state) => state.current,
    }),
    ...mapCustomersUsersFilters(['customer_id']),
    headers() {
      return [
        { text: '#ID', value: 'code' },
        { text: 'Cognome', value: 'last_name' },
        { text: 'Nome', value: 'first_name' },
        { text: 'Ruolo', value: 'role' },
        { text: 'E-Mail', value: 'email' },
        { text: 'Telefono', value: 'mobile_phone_number' },
        { text: 'Sede', value: 'customers_location.name' },
        { text: 'BU', value: 'business_unit' },
        { text: 'Matricola', value: 'external_id' },
        ...(this.currentTenantCustomerUser.show_vip === true
          ? [{ text: 'VIP', value: 'is_vip' }]
          : []),
        { text: 'Inserito il', value: 'created_at' },
      ]
    },
  },
  mounted() {
    this.setScopes(['group', 'location', 'platformuser'])
    this.customer_id = this.customer.id
  },
  beforeDestroy() {
    this.setScopes([])
    this.resetFilters()
  },

  methods: {
    ...mapActions('customersUsers', ['removeItem']),
    ...mapMutations('customersUsers', {
      setScopes: 'SET_SCOPES',
      setCurrent: 'SET_CURRENT',
      resetCurrent: 'RESET_CURRENT',
      resetFilters: 'RESET_FILTER_FIELDS',
    }),
    async remove(item) {
      const res = await this.$dialog.confirm({
        text:
          "Proseguire con l'eliminazione dell'utente ?\n l'azione non è reversibile!",
        title: 'Attenzione',
      })

      if (!res) return

      await this.removeItem(item.id)
      await this.$refs.table.refresh()
    },
    openModal(item) {
      const startingPoint = item.id ? item : { customer_id: this.customer.id }
      // Understand if the modal was opened as editing or for a new sub
      const isEditing = !!startingPoint.id
      this.editMode = isEditing
      this.setCurrent(startingPoint)
      this.dialog = true
    },
    onSubmitted() {
      this.modalClose()
      this.$refs.table.refresh()
    },
    modalClose() {
      this.dialog = false
      this.editMode = false
      this.resetCurrent()
    },
  },
}
</script>
